import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useQueryString } from './useQueryString';
import type { WritableComputedRef } from 'vue';

const parseRows = (rawValue: unknown): number | null => {
    const str = Array.isArray(rawValue) ? rawValue[0] : rawValue;
    const n = Number(str);
    return Number.isFinite(n) && n > 0 ? n : null;
};

export function useTablePageSize(tableKey: string, defaultSize = 10): WritableComputedRef<number> {
    defaultSize = Number.isFinite(defaultSize) && defaultSize > 0 ? defaultSize : 10;
    const route = useRoute();
    const { set } = useQueryString();
    const storageKey = `table-page-size:${tableKey}`;

    const getSaved = () => {
        const n = Number(localStorage.getItem(storageKey));
        return Number.isFinite(n) && n > 0 ? n : defaultSize;
    };

    watch(
        () => route.query['rows'],
        (rawValue) => {
            const n = parseRows(rawValue);
            if (n !== null) localStorage.setItem(storageKey, String(n));
        },
        { immediate: true }
    );

    return computed<number>({
        get: () => parseRows(route.query['rows']) ?? getSaved(),
        set: (next: number) => {
            set('rows', Number.isFinite(next) && next > 0 ? next : getSaved(), 'replace');
        },
    });
}
